import styled from "styled-components";
import MetaCounter from "_c/MetaCounter";

export const RemoveBtn = styled.button.attrs({
  className: "slider-remove-btn",
})`
  margin-top: 13px;
  font-weight: 600;
  font-size: 12px;
  color: var(--color-danger);
  @media (hover: hover) {
    visibility: hidden;
    :hover {
      opacity: 0.7;
    }
  }
  :focus {
    outline: 1px solid #d1179e !important;
  }
`;

export const Slide = styled.div`
  width: 170px;
  min-width: 170px;
  margin: 5px;
  position: relative;
  text-align: center;
  @media (hover: hover) {
    :hover {
      ${RemoveBtn} {
        visibility: visible;
      }
    }
  }
  @media (pointer: coarse) {
    margin-bottom: 10px;
  }
`;

export const Img = styled.img`
  width: 100%;
  max-width: 170px;
  height: 215px;
  margin: 0 auto;
  border-radius: 7px;
  cursor: pointer;
  &.flickity-lazyloaded,
  &.flickity-lazyerror {
    object-fit: cover;
  }
`;
export const MetaWrap = styled.div`
  display: flex;
  position: absolute;
  bottom: ${({ isOwner }) => (isOwner ? "40px" : "20px")};
  width: 100%;
  justify-content: space-between;
  padding: 0 10px;
`;
export const Meta = styled(MetaCounter)`
  margin: 0;
`;
